import {Component, Input} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

import {UtilsService} from '../services/utils';

declare let window:any;

const getDoc = function(body) {
  var doc = [
    '<html><head>',
    '<script src="https://code.jquery.com/jquery-2.2.1.min.js"></script>',
    '<link rel="stylesheet" type="text/css" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.6/css/bootstrap.min.css">',
    '<body>',
    body,
    '</body></html>',
  ];
  return doc.join('\n');
}

@Component({
    selector: 'demo',
    templateUrl: '../views/demo.pug',
    styles: [`
      iframe {
        width: 100%;
        height: 500px;
        border: 1px solid #ccc;
      }
    `],
})
export class DemoComponent {
  @Input() demoHTML;
  @Input() templateInput;
  viewing:string = 'demo';
  demoHTMLRendered:SafeHtml;
  demoHTMLHighlighted:string;
  error:string;

  constructor(private sanitizer:DomSanitizer, private utils:UtilsService) {}

  ngOnChanges() {
    this.refreshDemo();
  }

  refreshDemo() {
    if (!this.demoHTML) return;
    let html = this.utils.render(this.demoHTML, this.templateInput);
    if (html instanceof Error) {
      this.error = html.message;
      return;
    }
    if (html.indexOf('<html>') === -1) {
      html = getDoc(html);
    }
    this.demoHTMLRendered = this.sanitizer.bypassSecurityTrustHtml(html);
    this.demoHTMLHighlighted = window.Prism.highlight(html || '', window.Prism.languages.html);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/demo.ts